import { render, staticRenderFns } from "./etapas.vue?vue&type=template&id=79da6b44"
import script from "./etapas.ts?vue&type=script&lang=js&external"
export * from "./etapas.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79da6b44')) {
      api.createRecord('79da6b44', component.options)
    } else {
      api.reload('79da6b44', component.options)
    }
    module.hot.accept("./etapas.vue?vue&type=template&id=79da6b44", function () {
      api.rerender('79da6b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/pcp/etapas.vue"
export default component.exports